import { render } from "./RecentActivityFeed.vue?vue&type=template&id=520c902d&scoped=true"
import script from "./RecentActivityFeed.vue?vue&type=script&lang=js"
export * from "./RecentActivityFeed.vue?vue&type=script&lang=js"

import "./RecentActivityFeed.vue?vue&type=style&index=0&id=520c902d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520c902d"]])

export default __exports__